// Traduções dos marcadores temporais compartilhados.
export default {
  pt: { 'format.now': 'agora' },
  en: { 'format.now': 'now' },
  es: { 'format.now': 'ahora' },
}
